module.exports = __webpack_public_path__ + "img/active-News3.77e937f1.jpg";